<template>
    <highcharts class="hc" :ref="refId" :options="options" style="max-height: 500px"></highcharts>
</template>

<script>
    // utils
    import {getKey} from "../../utils/common";
    // constants
    import {chartColors} from "../../constants/chart-constants";
    // external
    import Highcharts from 'highcharts';
    import exportingInit from 'highcharts/modules/exporting';
    import exportingData from 'highcharts/modules/export-data';
    // mixins
    import ChartZoomControlMixin from "../../mixins/ChartZoomControlMixin";
    import ChartOptionsMixin from "../../mixins/ChartOptionsMixin";

    Highcharts.setOptions({
        colors: chartColors
    });

    exportingInit(Highcharts);
    exportingData(Highcharts);

    /**
     * Wrapper for highcharts component.
     * Has dynamic ref key and zoom reset handler.
     * Initializes localization for the chart and
     * holds the options for Column type charts.
     */

    export default {
        name: "ColumnChart",
        mixins: [ChartZoomControlMixin, ChartOptionsMixin],
        props: {
            zoomKey: {
                type: Number,
                required: true
            },
            data: {
                type: Object,
                required: true
            },
            metric: {
                type: String
            }
        },
        created() {
            Highcharts.setOptions({
                lang: this.getChartTranslations()
            });
        },
        computed: {
            options() {
                return {
                    ...this.data,
                    chart: {
                        zoomType: 'x',
                        type: 'column',
                    },
                    exporting: this.getChartExportingOptions(),
                    title: {
                        text: null
                    },
                    xAxis: {
                        type: 'datetime',
                        title: {
                            text: '',
                            style: {
                                color: "#6299EB"
                            }
                        },
                        startOnTick: true,
                        endOnTick: true,
                        min: this.data.startDate,
                        max: this.data.endDate
                    },
                    yAxis: {
                        min: 0,
                        title: {
                            text: this.$i18n.t(this.metric || 'sensors-page.y-label'),
                            style: {
                                color: "#6299EB"
                            }
                        },
                        floor: 0,
                        labels: {
                            x: 0,
                            y: -2
                        }
                    },
                    legend: {
                        enabled: true
                    },
                    credits: {
                        enabled: false
                    },
                    plotOptions: {
                        column: {
                            pointPadding: 0.2,
                            borderWidth: 0,
                            pointWidth: 3
                        }
                    }
                }
            },
            /**
             * Get a dynamic key for referencing the highcharts object.
             * NOTE: zoom level is controlled viz the zoomKey and this.
             */
            refId() {
                return getKey();
            }
        }
    };
</script>
